import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import ProfileView from '../../components/ProfileView/ProfileView';
import QuoteRequestModal from '../../components/Quotes/QuoteRequestModal';
import quoteService from '../../services/quoteService';
import { toast } from 'react-toastify';
import GuestWelcomeModal from '../../components/common/GuestWelcomeModal';

const PublicProfilePage = () => {
    const { username } = useParams();
    const { t } = useTranslation();
    const { isAuthenticated, user } = useAuth();

    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
    const [showWelcomeModal, setShowWelcomeModal] = useState(false);

    const handleOpenQuoteModal = () => {
        if (!isAuthenticated) {
            setShowWelcomeModal(true);
            return;
        }
        setIsQuoteModalOpen(true);
    };

    useEffect(() => {
        const fetchPublicProfile = async () => {
            try {
                const res = await api.get(`/profile/${username}`);
                setProfile(res.data);

                // Show welcome modal for guests after profile loads
                if (!isAuthenticated) {
                    const hasSeenWelcome = sessionStorage.getItem('hasSeenWelcome');
                    if (!hasSeenWelcome) {
                        setTimeout(() => {
                            setShowWelcomeModal(true);
                            sessionStorage.setItem('hasSeenWelcome', 'true');
                        }, 20000);
                    }
                }
            } catch (err) {
                console.error("Profile not found", err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };
        fetchPublicProfile();
    }, [username, isAuthenticated]);

    const handleQuoteSubmit = async (quoteData) => {
        try {
            await quoteService.createQuote(quoteData);
            toast.success(t('quote_request_sent') || 'Solicitação enviada com sucesso!');
        } catch (error) {
            console.error(error);
            toast.error(t('quote_request_failed') || 'Erro ao enviar solicitação.');
            throw error; // Re-throw to handle loading state in modal
        }
    };

    if (loading) return <div style={{ background: '#0a0a0a', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>{t('loading')}</div>;

    if (error || !profile) {
        return (
            <div style={{ padding: '40px', textAlign: 'center' }}>
                <h1 style={{ fontSize: '24px', marginBottom: '16px' }}>{t('profile_not_found')}</h1>
                <p style={{ color: '#8e8e8e', marginBottom: '24px' }}>{t('profile_not_found_desc', { username })}</p>
                <Link to="/home" style={{ color: '#0095f6', textDecoration: 'none', fontWeight: '600' }}>{t('back_to_home')}</Link>
            </div>
        );
    }

    return (
        <>
            <ProfileView
                data={profile.profile}
                username={username}
                onRequestQuote={
                    profile.profile?.type === 'artist' && profile.profile?.userId !== user?.id
                        ? handleOpenQuoteModal
                        : null
                }
            />
            {profile && profile.profile && (
                <QuoteRequestModal
                    isOpen={isQuoteModalOpen}
                    onClose={() => setIsQuoteModalOpen(false)}
                    artistProfileId={profile.profile.id}
                    artistName={profile.profile.artistName}
                    onSubmit={handleQuoteSubmit}
                />
            )}
            <GuestWelcomeModal
                isOpen={showWelcomeModal}
                onClose={() => setShowWelcomeModal(false)}
            />
        </>
    );
};

export default PublicProfilePage;
